import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the window and document element
    window.scrollTo(0, 0);
    document.documentElement.scrollTo(0, 0);

    // Also scroll nested containers that may have their own scroll on mobile
    const scrollableContainers = [
      ".dashboard-main",
      ".tournament-detail-routes-wrapper",
      ".landing-page",
    ];

    scrollableContainers.forEach((selector) => {
      const container = document.querySelector(selector);
      if (container) {
        container.scrollTo(0, 0);
      }
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
